import { useState } from 'react';
import { api, ApiError } from '../lib/api';
import { Notice } from './ui';

type Props = {
  /** phone mode: the user typed a number. card mode: the API sends to the card's own stored number. */
  phone?: string;
  cardToken?: string;
  onVerified: (token: string) => void;
  label?: string;
};

/** Reusable WhatsApp OTP step. Calls onVerified(token) with a verification token valid for one hour. */
export function OtpStep({ phone, cardToken, onVerified, label = 'تحقق' }: Props) {
  const [otpId, setOtpId] = useState('');
  const [devCode, setDevCode] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const sendPath = cardToken ? `/api/public/cards/${cardToken}/otp/send` : '/api/public/otp/send';
  const verifyPath = cardToken ? `/api/public/cards/${cardToken}/otp/verify` : '/api/public/otp/verify';
  async function send() {
    setBusy(true); setError('');
    try { const r = await api.post<{ otp_id: string; dev_code?: string }>(sendPath, cardToken ? {} : { phone }); setOtpId(r.otp_id); setDevCode(r.dev_code ?? ''); }
    catch (e) { setError(e instanceof ApiError ? (e.message_ar ?? e.message) : 'تعذر إرسال الرمز.'); }
    setBusy(false);
  }
  async function verify() {
    setBusy(true); setError('');
    try { const r = await api.post<{ verification_token: string }>(verifyPath, cardToken ? { otp_id: otpId, code } : { otp_id: otpId, phone, code }); onVerified(r.verification_token); }
    catch (e) { setError(e instanceof ApiError ? (e.message_ar ?? e.message) : 'الرمز غير صحيح.'); }
    setBusy(false);
  }
  if (!otpId) return (
    <div className="grid gap-3">
      <p className="muted text-sm">{phone ? <>نرسل رمزًا من 6 أرقام على واتساب الرقم <span className="num" dir="ltr">{phone}</span>.</> : 'نرسل رمزًا من 6 أرقام على واتساب رقمك المسجل.'}</p>
      {error && <Notice kind="danger">{error}</Notice>}
      <button className="btn btn-primary btn-lg" disabled={busy} onClick={send}>{busy ? 'لحظة...' : 'أرسل رمز التحقق على واتساب'}</button>
    </div>
  );
  return (
    <div className="grid gap-3">
      <p className="muted text-sm">أدخل الرمز الذي وصلك على واتساب.</p>
      {devCode && <Notice kind="warn">وضع التجربة: الرمز هو <b className="num">{devCode}</b></Notice>}
      <input className="field field-lg num" dir="ltr" inputMode="numeric" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))} aria-label="رمز التحقق" autoFocus />
      {error && <Notice kind="danger">{error}</Notice>}
      <button className="btn btn-primary btn-lg" disabled={busy || code.length !== 6} onClick={verify}>{busy ? 'لحظة...' : label}</button>
      <button className="btn btn-ghost" onClick={send} disabled={busy}>أعد الإرسال</button>
    </div>
  );
}
